import { LightGallery as ILightGallery } from 'lightgallery/lightgallery';
import { RefObject } from 'react';

export const useInvertImageColor = (lightGallery: RefObject<ILightGallery | null>) => {
  const toggleInvert = () => {
    if (!lightGallery.current) return;

    const currentIndex = lightGallery.current.index;
    const currentSlide = lightGallery.current.getSlideItem(currentIndex).get();
    if (currentSlide) {
      const imgElement = currentSlide.querySelector('img');

      if (!imgElement) return;

      const isInverted = imgElement.style.filter === 'invert(100%)';
      imgElement.style.filter = isInverted ? 'none' : 'invert(100%)';
    }
  };

  return () => {
    const toolbar = document.querySelector('.lg-toolbar');

    if (toolbar && !toolbar.querySelector('.lg-custom-invert')) {
      const invertButton = document.createElement('button');
      invertButton.className = 'lg-custom-invert lg-icon';
      invertButton.innerHTML = `<span style="display:flex; justify-content: center;">◐</span>`;
      invertButton.style.cursor = 'pointer';
      invertButton.onclick = toggleInvert;
      toolbar.appendChild(invertButton);
    }
  };
};
